import { ElementTypes } from '../element-types';

export class PolicyWording {
  private static readonly prefix: string = 'policy-wording';
  static readonly PdsLink: string = `${PolicyWording.prefix}-${ElementTypes.Link}-pds`;
}
